import { InputChk } from '@/shared/ui';

interface ByClassStudentFilterProps {
    filterClassList: API.MyClassMemberList.ClassData[];
    checkKeyList: string[];
    claIdListData: { key: string; checked: boolean; claId: string[] }[];
    selectClass?: {
        name: string;
        claId: string;
    };
    setSelectClass: (value: { name: string; claId: string }) => void;
}

export const ByClassStudentFilter = ({
    filterClassList,
    selectClass,
    setSelectClass,
}: ByClassStudentFilterProps) => {
    const transformToClassList = (data: API.MyClassMemberList.ClassData[]) => {
        return data.map((item) => {
            const { schName, clsName, classSeq, schCode, crtYear, schYear } = item.classInfo;

            const processedSchName = schName?.replace('등학교', '');
            const claId = 'viva-' + schCode + '-' + crtYear + '-' + schYear + '-' + classSeq;
            return {
                name: `${processedSchName} ${clsName}`,
                claId,
            };
        });
    };

    const classList = transformToClassList(filterClassList || []);

    return (
        <div className="table-input table-style1 // con-mt1">
            <table>
                <colgroup>
                    <col style={{ width: '121px' }} />
                    <col />
                </colgroup>
                <tbody>
                    <tr>
                        <th scope="row">클래스 선택</th>
                        <td colSpan={3} className="chk-gap1">
                            {classList && classList?.length > 0
                                ? classList.map((classItem) => (
                                      <InputChk
                                          key={classItem?.claId}
                                          type="radio"
                                          forId={`filterChk1-${classItem?.claId}`}
                                          checked={
                                              selectClass && selectClass.claId === classItem?.claId
                                          }
                                          onChange={(e) => setSelectClass(classItem!)}
                                      >
                                          <span className="txt">{classItem?.name}</span>
                                      </InputChk>
                                  ))
                                : '아직 발행한 클래스가 없습니다.'}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
